export default {
  deposit: {
    crypto: 'Tiền điện tử',
    fiatOrCash: 'Tiền pháp định/Tiền mặt',
    depositCurrency: 'Tiền tệ nạp',
    chooseNetwork: 'Chọn mạng',
    depositAddress: 'Địa chỉ nạp tiền',
    copy: 'Sao chép',
    copied: 'Đã sao chép!',
    close: 'Đóng',
    more: 'Thêm',
    select: 'Chọn',
    channel: 'Kênh',
    loading: 'Đang tải...',
    noCurrency: 'Không có tiền tệ',
    bonusTip: 'Tận hưởng tiền thưởng nạp lần đầu lên đến 200% tín dụng bổ sung.',
    minDeposit: 'Nạp tối thiểu',
    sendOnly: 'Chỉ gửi {currency} đến địa chỉ này. Tiền sẽ được nạp tự động sau {confirmations} xác nhận mạng.',
    depositAmount: 'Số tiền nạp',
    enterAmount: 'Nhập số tiền',
    confirmDeposit: 'Xác nhận nạp',
    depositTitle: 'Nạp tiền',
    selectChannel: 'Chọn kênh',
    subtitle: 'Nhanh chóng, an toàn và tiện lợi',
    secureEncrypted: 'An toàn và mã hóa',
    terms: 'Khi tiếp tục, bạn đồng ý với Điều khoản & Điều kiện của chúng tôi',
    totalDepositAmount: 'Tổng số tiền nạp',
    fee: 'Phí',
    arrivalAmount: 'Số tiền được ghi có',
    payMethod: 'Phương thức thanh toán',
    cpf: 'CPF',
    enterCpf: 'Vui lòng nhập CPF',
    depositSuccess: 'Nạp thành công!',
    depositFailed: 'Nạp thất bại, vui lòng thử lại.',
    mockArrive: 'Mô phỏng nhận tiền (Thử nghiệm)',
    activity: {
      firstChargeTitle: 'Sự kiện đăng ký nạp lần đầu',
      firstChargeSubtitle: 'Đăng ký lần nạp đầu tiên để nhận phần thưởng độc quyền',
      dailyThreeTitle: 'Ba lần nạp mỗi ngày',
      dailyThreeSubtitle: 'Hoàn thành 3 lần nạp mỗi ngày để nhận thưởng thêm',
      dailyPreviewLabel: 'Thưởng nạp lần đầu',
      upTo: 'Tối đa {amount} {unit}',
      safeTitle: 'Tiền của bạn được bảo vệ an toàn',
      safeDesc: 'Chúng tôi sử dụng bảo mật hàng đầu ngành để bảo vệ giao dịch và thông tin cá nhân của bạn.',
      dailyFirst: 'Nạp lần 1 hàng ngày',
      dailySecond: 'Nạp lần 2 hàng ngày',
      dailyThird: 'Nạp lần 3 hàng ngày',
      lossReward: 'Hoàn trả thua lỗ',
      lossRewardSubtitle: 'Nhận hoàn tiền trên khoản thua lỗ của bạn',
      rebateUpTo: 'Hoàn trả lên đến {ratio}%',
      notEligible: 'Bạn không còn đủ điều kiện tham gia hoạt động này',
      lossNeedSelect: 'Chọn hoạt động này khi nạp tiền để tham gia hoàn tiền',
      claimed: 'Đã nhận',
      claim: 'Nhận',
      noTier: 'Không có cấp bậc',
      claimWillOpen: 'Mở nhận lúc {time}',
      claimTimeNotReached: 'Chưa đến giờ nhận. Vui lòng quay lại sau {time}.',
      bonus: 'Thưởng',
      rebate: 'Hoàn trả',
      depositGE: 'Nạp ≥ {amount}',
      lossGE: 'Thua ≥ {amount}',
      claimSuccess: 'Nhận thành công',
      claimFailed: 'Nhận thất bại',
      alreadyClaimed: 'Bạn đã nhận cấp này rồi. Vui lòng không nhấp lại.',
      lossAlreadyClaimed: 'Bạn đã nhận hoàn trả cấp này rồi. Vui lòng không nhấp lại.',
      requireLogin: 'Vui lòng đăng nhập trước khi nhận.',
      depositNotEnough: 'Số tiền nạp chưa đạt yêu cầu. Hãy tiếp tục cố gắng!',
      lossNotEnough: 'Số tiền thua hôm qua chưa đạt yêu cầu.',
      onlyHighest: 'Phần thưởng hoạt động này chỉ cho phép nhận ở mức cao nhất.',
    },
  },
};
